import React, { useState, useEffect } from 'react';

export default function ScreenshotCarousel({
  images = [
    '/screenshots/tome-1.png',
    '/screenshots/tome-2.png',
    '/screenshots/tome-3.png',
  ],
  autoPlay = true,
  interval = 4000,
}) {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    if (!autoPlay || images.length <= 1) return;
    const id = setInterval(() => setIndex((i) => (i + 1) % images.length), interval);
    return () => clearInterval(id);
  }, [autoPlay, interval, images.length]);

  function prev() {
    setIndex((i) => (i - 1 + images.length) % images.length);
  }

  function next() {
    setIndex((i) => (i + 1) % images.length);
  }

  return (
    <div className="carousel">
      <div className="carousel-window">
        {images.map((src, i) => (
          <img
            key={i}
            src={src}
            alt={`Screenshot ${i + 1}`}
            className={`carousel-img ${i === index ? 'active' : ''}`}
          />
        ))}
      </div>

      {images.length > 1 && (
        <>
          <button className="carousel-btn left" onClick={prev} aria-label="Previous">‹</button>
          <button className="carousel-btn right" onClick={next} aria-label="Next">›</button>

          <div className="carousel-dots">
            {images.map((_, i) => (
              <button
                key={i}
                className={`dot ${i === index ? 'active' : ''}`}
                onClick={() => setIndex(i)}
                aria-label={`Go to slide ${i + 1}`}
              />
            ))}
          </div>
        </>
      )}
    </div>
  );
}
